import { getAPIDomain, http } from 'utils/http';
import { PrejoinResponse, ValidateRoomPayload } from 'features/room/types';
import { UserName } from 'features/users/types';
import { getBrowserId } from 'utils/getBrowserId';

export const validateRoomService = async (roomId: string, token?: string) => {
  const response = await http.get<ValidateRoomPayload>(
    `/room-api/${roomId}/validate?domain=${getAPIDomain()}`,
    {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }
  );

  return response.data;
};

export const loginRoomService = async (
  roomUrlId: string,
  name?: UserName,
  initials?: string,
  token?: string
) => {
  const response = await http.post<PrejoinResponse>(
    `/room-api/${roomUrlId}/prejoin`,
    {
      name,
      initials,
      domain: getAPIDomain(),
      uniqueId: getBrowserId(),
    },
    {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }
  );

  return response.data;
};
